import { render, staticRenderFns } from "./index.vue?vue&type=template&id=41a8a9ea&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=41a8a9ea&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a8a9ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\my-code\\cestc\\xiangyun\\web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41a8a9ea')) {
      api.createRecord('41a8a9ea', component.options)
    } else {
      api.reload('41a8a9ea', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=41a8a9ea&scoped=true", function () {
      api.rerender('41a8a9ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/Footer/index.vue"
export default component.exports